import { ArticleType, TravelArticleDetails } from '@nemuru-eng/js-api-client';

import { TravelFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Travel/types/TravelFormItem';
import { Item } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/Item';
import { numberOfNights } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/numberOfNights';

export class TravelItem extends Item<TravelFormItem> {
  constructor(data: TravelFormItem) {
    super({
      ...data,
      description: data.description || TravelItem.description(data),
    });
  }

  protected isCompleted(): boolean {
    return !!this.data.travelCategory && !!this.data.startDate && !!this.data.endDate && !!this.data.destination;
  }

  protected toForm(): TravelFormItem {
    return {
      ...this.toMinimalFormItem(),
      optionalDescription: this.data.optionalDescription,
      travelCategory: this.data.travelCategory,
      startDate: this.data.startDate,
      endDate: this.data.endDate,
      destination: this.data.destination,
      travellers: this.data.travellers,
    } as TravelFormItem;
  }

  protected toDto(): object {
    return {
      name: TravelItem.description(this.data),
      description: TravelItem.description(this.data),
      travelCategory: this.data.travelCategory,
      startDate: this.data.startDate,
      endDate: this.data.endDate,
      destination: this.data.destination.trim(),
      travellers: !!this.data.travellers && parseInt(this.data.travellers),
    };
  }

  public static fromOrderLineDto(units: number, article: TravelArticleDetails): TravelItem {
    const formData: TravelFormItem = {
      // Minimal form item fields
      units: units.toString(),
      vat: '21', // FIXME: Default VAT
      price: article.price.amount.toFixed(2).toString(),
      category: article.category,

      // ArticleType-specific fields
      type: ArticleType.TRAVEL,
      optionalDescription: article.description || article.name || article.reference || '',
      travelCategory: article.travelCategory,
      startDate: article.startDate as Date,
      endDate: article.endDate as Date,
      destination: article.destination || '',
      travellers: article.numberOfTravellers?.toString() || '',
    };

    return new TravelItem(formData);
  }

  private static description(data: TravelFormItem): string {
    if (data.optionalDescription) {
      return data.optionalDescription;
    }

    if (data.destination && data.startDate && data.endDate) {
      return `${data.destination.trim()} (${numberOfNights(data.startDate, data.endDate)} noches)`;
    }

    return data.description ?? data.destination ?? '';
  }
}
